export default function isIOS() {
  if (navigator.platform) {
    if (
      (/iPhone|iPhone Simulator/.test(navigator.platform) ||
        (navigator.platform === 'MacIntel' &&
          navigator.maxTouchPoints > 1)) &&
      !window.MSStream
    ) {
      return true
    }
    return false
  }
  return false
}
